const DEFAULT_PASS_THROUGH_KEYS = ['sort'] as const;

const splitPathAndQuery = (url: string): { pathName: string; searchParams: URLSearchParams } => {
  const queryIndex = url.indexOf('?');
  if (queryIndex === -1) {
    return { pathName: url, searchParams: new URLSearchParams() };
  }
  return {
    pathName: url.slice(0, queryIndex),
    searchParams: new URLSearchParams(url.slice(queryIndex + 1)),
  };
};

/**
 * Copies listing pass-through query keys from the SEO `fromUrl` onto `toUrl`
 * when the redirect response omits them (e.g. sort=popular on a character
 * permalink). Does not overwrite keys already present on `toUrl`.
 */
export const mergeListingQueryOntoSeoToUrl = (
  fromUrl: string,
  toUrl: string,
  keys: readonly string[] = DEFAULT_PASS_THROUGH_KEYS,
): string => {
  const fromParts = splitPathAndQuery(fromUrl);
  const toParts = splitPathAndQuery(toUrl);

  for (const key of keys) {
    if (toParts.searchParams.has(key)) continue;
    const value = fromParts.searchParams.get(key);
    if (!value) continue;
    if (key === 'sort' && value === 'hotNew') continue;
    toParts.searchParams.set(key, value);
  }

  const queryString = toParts.searchParams.toString();
  return queryString ? `${toParts.pathName}?${queryString}` : toParts.pathName;
};
